import React from 'react'

function Home() {
    return (
        <div className='reusablechart-component'>
            <div className='reusable-header'>
                Chartpedia
            </div>
            <div className='note'>
                <p className='para'>
                    Welcome to Chartpedia, the ultimate resource for all things related to charts! Our mission
                    is to provide a <span>comprehensive</span> and <span>user-friendly</span> platform for chart enthusiasts to explore,
                    discover, and share their favorite charts with the world.
                </p>
                <br />
                <p className='para'>
                    At Chartpedia, you'll find a vast collection of charts from various domains, including <strong><i>finance,
                    economics, science, technology</i></strong>, and more. Our database is constantly updated with the latest charts
                    and data visualizations from trusted sources, ensuring that you always have access to the most
                    up-to-date information.
                </p>
                <br />
                <p className='para'>
                    Whether you're a <strong><i>data analyst, researcher</i></strong>, or simply someone who loves charts, Chartpedia has
                    something for you. Our easy-to-use interface allows you to search for charts by category, keyword,
                    or data source, making it easy to find the information you need quickly and efficiently.
                </p>
                <br />
                <p className='para'>
                    But Chartpedia is more than just a collection of charts. We also provide in-depth analysis and
                    commentary on the latest trends and developments in the world of data visualization. Our team of
                    experts is always on the lookout for new and innovative ways to present data, and we share our
                    insights and observations with our users to help them stay ahead of the curve.
                </p>
                <br />
                <h1>
                    <i>So why wait? Start exploring Chartpedia today and discover the power of data visualization!</i>
                </h1>
            </div>
        </div>
    )
}

export default Home;